// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2014 Minted Inc.
 *
 * All Rights Reserved
 */


(function (M, Backbone, $, _) {
  "use strict";

  M.Model = M.Model || {};
  M.Model.Order = M.Model.Order || {};

  /**
   * Model for the order status notification bar. This model polls the
   * server for changes to the order information.
   */
  M.Model.Order.OrderStatus = Backbone.Model.extend({
    urlRoot: '/order/detail/status/',

    // How often the model polls the server (set to 5 minutes).
    refreshRate: 300000,

    /**
     * Creates an OrderStatus model.
     * @param userModel - A M.Model.Base.LoggedInUser object.
     */
    initialize: function() {
      this.get('userModel').bind('change', this.onUserIdChange.bind(this));

      // Start polling immediately if the user is logged in.
      if (this.isUserLoggedIn()) {
        this.startPolling();
      }
    },

    url: function() {
      return this.urlRoot + this.get('userModel').get('userId');
    },

    isKnownVisitor: function() {
      return this.get('isVisitor');
    },

    isLoggedInUser: function() {
      return this.get('userModel').get('userId') !== 0;
    },

    isUserLoggedIn: function() {
      return this.isLoggedInUser() || this.isKnownVisitor();
    },

    startPolling: function() {
      this.fetch();
      this.refreshInterval = window.setInterval(this.fetch.bind(this),
        this.refreshRate);
    },

    stopPolling: function() {
      window.clearInterval(this.refreshInterval);
    },

    /**
     * This is called when the user's state changes, if the user logs out,
     * the polling is stopped.
     */
    onUserIdChange: function() {
      if (!this.isUserLoggedIn()) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
    }
  });
})(M, Backbone, jQuery, _);
